export const BASE_DATE_FORMAT = 'll HH:mm';
export const SHORT_DATE_FORMAT = 'DD/MM/YYYY';
export const FULL_DATE_FORMAT = 'MMM. DD, YYYY  HH:mm';
export const CREATE_DATE_FORMAT = 'MMMM DD, YYYY';
export const CREATE_DATE_FORMAT_SHORT = 'MMM DD, YYYY';

